import { defineMessages } from "react-intl";

export const channelsAvailabilityDialogMessages = defineMessages({
  noChannels: {
    id: "mTEqYL",
    defaultMessage: "No channels to assign. Please first assign them for the product.",
    description: "NoChannels content",
  },
});
